import React from 'react'

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function Loading () {
    return(	
        <Stack spacing={3}>
            <Skeleton variant="text" animation="wave" width={'30%'} style={{"marginLeft": "65%"}}/>
            <Skeleton variant="text" animation="wave"/>
            <Skeleton variant="rectangular" animation="wave" height={30} />
            <Skeleton variant="text" animation="wave"/>
            <Skeleton key={'h1'} variant="rectangular" animation="wave" height={200}/>
        </Stack>
    )
}
